import { z } from 'zod';
/**
 * Machine-readable error codes. Clients branch on `code`, never on `message`.
 * Codes are append-only: renaming or removing one is a breaking API change.
 */
export const ERROR_CODES = [
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'PAYLOAD_TOO_LARGE',
    'UNSUPPORTED_MEDIA_TYPE',
    'RATE_LIMITED',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    'IMMUTABLE_RECORD',
    'INVALID_STATE_TRANSITION',
    'INVARIANT_VIOLATION',
    'VERSION_CONFLICT',
    'REAUTHENTICATION_REQUIRED',
    'MFA_ENROLLMENT_REQUIRED',
    'CSRF_TOKEN_INVALID',
    'AI_UNAVAILABLE',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const apiErrorDetailSchema = z.object({
    path: z.string(),
    code: z.string(),
    message: z.string(),
});
export const apiErrorEnvelopeSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        requestId: z.string(),
        details: z.array(apiErrorDetailSchema).optional(),
    }),
});
//# sourceMappingURL=error-envelope.js.map